import { useState } from 'react';
import { RolesApi } from '@/api/clients/roles/roles.api';

export const useCreateRole = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createRole = async (roleData) => {
    setLoading(true);
    setError(null);

    try {
      const response = await RolesApi.createRole(roleData);
      return response.data?.data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || 'Failed to create role';
      setError(errorMessage);
      console.error('Error creating role:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => {
    setError(null);
  };

  return {
    createRole,
    loading,
    error,
    clearError,
  };
};
